import { render, staticRenderFns } from "./WineEdit_Desktop.vue?vue&type=template&id=189f272e&scoped=true&"
import script from "./WineEdit_Desktop.vue?vue&type=script&lang=js&"
export * from "./WineEdit_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./WineEdit_Desktop.vue?vue&type=style&index=0&id=189f272e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f272e",
  null
  
)

export default component.exports